
import React from 'react';
import {useTranslation} from "react-i18next";
import AccordionItemCustom from "../components/accordion";
import Helmet from "react-helmet";
import {Link} from "react-router-dom";
import Zoom from 'react-medium-image-zoom'
import LEGAL_LINKS from '../core/data/links/legal_links';

function InfoPage(props) {

    const { t, i18n } = useTranslation()

    //TODO: add Telegram donate

    const paymentsData = [
        {
            name: "USDT",
            network: "TRC20",
            address: "TVUAA7f5kjnVJtauKRb6GxW6DaWqkW8fbY",
        },
        // {
        //     name: "TRX",
        //     network: "BEP20",
        //     address: "0x7c4eCc999769b2A10c44E29c2A68E862615Be86d",
        // },
        // {
        //     name: "Monero",
        //     network: "xmr",
        //     address: "46CAby5RGmLc5gqLvbeoRA2N83krk4yrGFyfoHE2epL4XPECBoKTh3rAbqyhbvZgQMbrnT66wtuL1YeFDjsZpPzY4K8ecVZ",
        // },
        // {
        //     name: "BTC",
        //     network: "btc",
        //     address: "bc1qqzys2fplz4ck8ekelj9fnjh236uzadq6h887d6",
        // }
    ];

    const paymentsBank = [
        {
            name: "PrivatBank",
            network: "IBAN",
            address: "UA32 305299 0000 0262 0388 1726897",
        },
    ];

    const copyToClipboard = (value) => {
        navigator.clipboard.writeText(value).then(function() {
            console.log('Async: Copying to clipboard was successful!');
            alert('Copied to clipboard ' + value)
        }, function(err) {
            console.error('Async: Could not copy text: ', err);
        });
    }

    return (<div className={'min-vh-100 pt-5 pb-5'}>

        <Helmet>
            <title>Information - Yaroslav Lukyanchuk</title>
            <meta name="description" content="Yaroslav Lukyanchuk" />
        </Helmet>

        <div className="container text-dark text-start pt-5 mt-5">
            <h1>{t('nav.info')}</h1>

            <div className="content-info">
                <div className="col-12 col-md-12 m-auto" />

                <div className="section mt-5 d-flex flex-wrap">
                    <div className="col-md-4 col-12">
                        <h2>
                            Links
                        </h2>
                    </div>
                    <div className="col-md-8 col-12">
                        <div className="d-flex flex-wrap justify-content-between">
                            <Link to="/links" className={'text-decoration-none text-secondary nav-link'}>Link tree
                                <svg className="w-6 h-6 text-gray-800 dark:text-white m-1" aria-hidden="true"
                                     xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                     fill="none" viewBox="0 0 24 24">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                          stroke-width="2"
                                          d="M18 14v4.833A1.166 1.166 0 0 1 16.833 20H5.167A1.167 1.167 0 0 1 4 18.833V7.167A1.166 1.166 0 0 1 5.167 6h4.618m4.447-2H20v5.768m-7.889 2.121 7.778-7.778"/>
                                </svg>
                            </Link>
                            <Link to="/cooperation" className={'text-decoration-none text-secondary nav-link'}>Cooperation
                                <svg className="w-6 h-6 text-gray-800 dark:text-white m-1" aria-hidden="true"
                                     xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                     fill="none" viewBox="0 0 24 24">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                          stroke-width="2"
                                          d="M18 14v4.833A1.166 1.166 0 0 1 16.833 20H5.167A1.167 1.167 0 0 1 4 18.833V7.167A1.166 1.166 0 0 1 5.167 6h4.618m4.447-2H20v5.768m-7.889 2.121 7.778-7.778"/>
                                </svg>
                            </Link>
                            <Link to="/card" className={'text-decoration-none text-secondary nav-link'}>Business Card
                                <svg className="w-6 h-6 text-gray-800 dark:text-white m-1" aria-hidden="true"
                                     xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                     fill="none" viewBox="0 0 24 24">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                          stroke-width="2"
                                          d="M18 14v4.833A1.166 1.166 0 0 1 16.833 20H5.167A1.167 1.167 0 0 1 4 18.833V7.167A1.166 1.166 0 0 1 5.167 6h4.618m4.447-2H20v5.768m-7.889 2.121 7.778-7.778"/>
                                </svg>
                            </Link>
                            <Link to="/project/tracking" className={'text-decoration-none text-secondary nav-link'}>
                                Project Tracking
                                <svg className="w-6 h-6 text-gray-800 dark:text-white m-1" aria-hidden="true"
                                     xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                     fill="none" viewBox="0 0 24 24">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                          stroke-width="2"
                                          d="M18 14v4.833A1.166 1.166 0 0 1 16.833 20H5.167A1.167 1.167 0 0 1 4 18.833V7.167A1.166 1.166 0 0 1 5.167 6h4.618m4.447-2H20v5.768m-7.889 2.121 7.778-7.778"/>
                                </svg>
                            </Link>
                            <Link to="/site-map" className={'text-decoration-none text-secondary nav-link'}>Site map
                                <svg className="w-6 h-6 text-gray-800 dark:text-white m-1" aria-hidden="true"
                                     xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                     fill="none" viewBox="0 0 24 24">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                          stroke-width="2"
                                          d="M18 14v4.833A1.166 1.166 0 0 1 16.833 20H5.167A1.167 1.167 0 0 1 4 18.833V7.167A1.166 1.166 0 0 1 5.167 6h4.618m4.447-2H20v5.768m-7.889 2.121 7.778-7.778"/>
                                </svg>
                            </Link>
                        </div>
                    </div>
                </div>

                <div className="section mt-5 d-flex flex-wrap">
                    <div className="col-md-4">
                        <h2>FAQ</h2>
                        <small>Question & Answer</small>
                    </div>
                    <div className="col-md-8">
                        <AccordionItemCustom data={[
                            {
                                id: 0,
                                title: "Як дізнатись в на якому етапі розробка проекту?",
                                content: <div>
                                    <p>
                                        Для зручності клієнта створений мобільний застосунок, щоб відслідковувати поточний статус проекту, де зручно переглянути на якому етапі розробки знаходиться проект, є можливість залишити питання, додати коментар а також внести правки на поточному етапі розробки.
                                        Ви можете завантажити мобільний застосунок - Android App
                                        або перейти на сторінку Відслідковування проекту.
                                    </p>
                                </div>
                            },
                            {
                                id: 1,
                                title: "How me Tracking project status?",
                                content: <div>
                                    <p>
                                        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusantium ad aliquam aperiam autem doloremque eum iusto quas quasi ratione, sequi sunt unde ut, voluptate. Esse illum natus unde velit voluptatum?
                                    </p>
                                    <a href="/project/tracking" className={'display- text-decoration-none bg-dark text-white p-3 pt-2'}> <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="currentColor"
                                                                                                                                              className="bi bi-arrow-right" viewBox="0 0 16 16">
                                        <path fill-rule="evenodd"
                                              d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"/>
                                    </svg> Tracking project </a>
                                </div>
                            },
                            {
                                id: 2,
                                title: "Як зрозуміти, що саме мені потрібно?",
                                content: <div>
                                    <p>
                                        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aliquam aliquid error esse et excepturi hic, id inventore ipsum laboriosam maiores maxime, neque nobis pariatur quae quis sed sequi sit soluta.
                                    </p>
                                    {/*<ul>*/}
                                    {/*    <li>*/}
                                    {/*        Скористайтесь формой для співпраці*/}
                                    {/*    </li>*/}
                                    {/*    <li>*/}
                                    {/*        Зателефонуйте за номером 098 075 13 57*/}
                                    {/*    </li>*/}
                                    {/*    <li>*/}
                                    {/*        Напишіть на email: yarik@lukyanchuk.com*/}
                                    {/*    </li>*/}
                                    {/*    <li>*/}
                                    {/*        Через месенджер Whatsapp / Telegram / Viber*/}
                                    {/*    </li>*/}
                                    {/*    <li>*/}
                                    {/*        Соціальні мережі*/}
                                    {/*    </li>*/}
                                    {/*</ul>*/}
                                </div>
                            }
                        ]} />
                    </div>
                </div>

                <div className="section mt-5 d-flex flex-wrap">
                    <div className="col-md-4">
                        <h2>
                            Donate
                        </h2>
                        <small>Tips for Сoffee</small>
                    </div>
                    <div className="col-md-8">
                        <AccordionItemCustom data={[
                            {
                                id: 2,
                                title: "PayPal",
                                content: <div>
                                    <div className="d-flex flex-wrap align-items-start justify-content-between">
                                        <div className={'col-md-auto d-flex align-items-start 1justify-content-start'}>
                                            <Zoom>
                                                <img src="/assets/img/qr/paypal.png" alt="paypal qr code payments" className={'img-fluid p-2 border'}/>
                                            </Zoom>
                                        </div>


                                        <div className={'sticky-top'}>
                                            <form action="https://www.paypal.com/donate" method="post" target="_top">
                                                <input type="hidden" name="hosted_button_id" value="V9YGTAHG9S94Q" />
                                                <input type="image" src="https://pics.paypal.com/00/s/YmIyOGMzMGEtN2QzNS00YmY3LWI3MjMtZGZlOWYxZDQ1ZDhl/file.PNG" border="0" name="submit" title="PayPal - The safer, easier way to pay online!" alt="Donate with PayPal button" />
                                                <img alt="" border="0" src="https://www.paypal.com/en_UA/i/scr/pixel.gif" width="1" height="1" />
                                            </form>

                                        </div>

                                    </div>

                                </div>
                            },
                            {
                                id: 2,
                                title: "Bank credentials",
                                content: <div>
                                    <div className="d-flex flex-wrap align-items-start justify-content-between">

                                        <div className="col-md-4">
                                            <img src="/assets/img/bank/a.jpg" alt="A-Bank" className={'img-fluid rounded-5'}/>
                                        </div>

                                        {
                                            paymentsBank.map((pay) => <div className={'col-md-auto'}>
                                                <h3 className={'mt-5'}>
                                                    {pay.name}
                                                </h3>
                                                <small className="text-secondary">
                                                    {pay.network}
                                                </small>
                                                <p>
                                                    {pay.address}
                                                </p>
                                                <button className={'btn btn-dark rounded-pill p-3 pt-2 pb-2'} onClick={() => copyToClipboard(pay.address)}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                         fill="currentColor" className="bi bi-copy" viewBox="0 0 16 16">
                                                        <path fill-rule="evenodd"
                                                              d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z"/>
                                                    </svg>
                                                    <small className="p-1">Copy address</small>
                                                </button>
                                            </div>)
                                        }

                                    </div>

                                </div>
                            },
                            {
                                id: 2,
                                title: "Crypto",
                                content: <div>
                                    {/*TODO: add QR code*/}
                                    <div className="d-flex flex-wrap align-items-start justify-content-between">
                                        {
                                            paymentsData.map((pay) => <div className={'col-md-auto'}>
                                                <h3 className={'mt-5'}>
                                                    {pay.name}
                                                </h3>
                                                <small className="text-secondary">
                                                    {pay.network}
                                                </small>
                                                <p>
                                                    {pay.address}
                                                </p>
                                                <button className={'btn btn-dark rounded-pill p-3 pt-2 pb-2'} onClick={() => copyToClipboard(pay.address)}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                         fill="currentColor" className="bi bi-copy" viewBox="0 0 16 16">
                                                        <path fill-rule="evenodd"
                                                              d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z"/>
                                                    </svg>
                                                    <small className="p-1">Copy address</small>
                                                </button>
                                            </div>)
                                        }

                                    </div>

                                </div>
                            },

                        ]} />
                    </div>
                </div>

                <div className="section mt-5 d-flex flex-wrap">
                    <div className="col-md-4">
                        <h2>
                            Legal
                        </h2>
                    </div>
                    <div className="col-md-8 d-flex flex-wrap">
                        {
                            LEGAL_LINKS.map((link, i) => <>
                                <Link to={link.url + link.slug + '.pdf'} target={'_blank'} className={'text-decoration-none text-secondary nav-link'}>  {link.icon} {link.title.en}
                                    <svg className="w-6 h-6 text-gray-800 dark:text-white m-1" aria-hidden="true"
                                         xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                         fill="none" viewBox="0 0 24 24">
                                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                              stroke-width="2"
                                              d="M18 14v4.833A1.166 1.166 0 0 1 16.833 20H5.167A1.167 1.167 0 0 1 4 18.833V7.167A1.166 1.166 0 0 1 5.167 6h4.618m4.447-2H20v5.768m-7.889 2.121 7.778-7.778"/>
                                    </svg>
                                </Link>
                            </>)
                        }
                    </div>
                </div>

            </div>

        </div>
    </div>);
}

export default InfoPage;
